import { cssClasses } from 'pkg/css/utils';

import * as css from './styles.css';

interface SpinnerProps {
	size?: string;
	color?: string;
	duration?: string;
	center?: boolean;
	className?: string;
}

export const EllipsisIcon = (props: SpinnerProps) => {
	const size = props.size || '100px';
	return (
		<svg
			viewBox="0 0 100 60"
			width={size}
			height={size}
			className={props.className}>
			<g transform="translate(25 30)">
				<circle cx="0" cy="0" r="6" fill="currentColor">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.233s"
						calcMode="linear"
						values="0;1;0"
						keyTimes="0;0.5;1"
						dur={props.duration || '0.7s'}
						repeatCount="indefinite"
					/>
				</circle>
			</g>
			<g transform="translate(50 30)">
				<circle cx="0" cy="0" r="6" fill="currentColor">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="-0.116s"
						calcMode="linear"
						values="0;1;0"
						keyTimes="0;0.5;1"
						dur={props.duration || '0.7s'}
						repeatCount="indefinite"
					/>
				</circle>
			</g>
			<g transform="translate(75 30)">
				<circle cx="0" cy="0" r="6" fill="currentColor">
					<animateTransform
						attributeName="transform"
						type="scale"
						begin="0s"
						calcMode="linear"
						values="0;1;0"
						keyTimes="0;0.5;1"
						dur={props.duration || '0.7s'}
						repeatCount="indefinite"
					/>
				</circle>
			</g>
		</svg>
	);
};

export const Spinner = (props: SpinnerProps) => (
	<div
		className={cssClasses(css.spinner, props.center && css.center)}
		style={{
			width: props.size ? props.size : undefined,
			color: props.color ? props.color : undefined,
		}}>
		<EllipsisIcon {...props} />
	</div>
);
